import { useMemo } from "react";
import { cn } from "utils";

const SKILL_PILL_CLASS =
  "inline-flex items-center gap-1.5 px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 rounded-md hover:bg-gray-200 transition-colors max-w-full";

const CompactSkillsList = ({ hit, onSkillClick, onViewAllClick }) => {
  const visibleCount = 3;

  const talentSkills = useMemo(() => {
    const skillsMap = new Map();
    const addSkills = (skills) => {
      skills?.forEach((skill) => {
        const key = `${skill.name}_${skill.category}`;
        if (!skillsMap.has(key)) {
          skillsMap.set(key, skill);
        }
      });
    };

    (hit.careers || []).forEach((career) => addSkills(career?.TKSkills));
    (hit.resumeWorkHistory || []).forEach((entry) =>
      addSkills(entry?.TKSkills)
    );

    return Array.from(skillsMap.values()).slice(0, 15);
  }, [hit.careers, hit.resumeWorkHistory]);

  const visibleSkills = talentSkills.slice(0, visibleCount);
  const remainingCount = talentSkills.length - visibleCount;

  if (talentSkills.length === 0) {
    return <p className="text-sm text-gray-400 italic">No skills listed</p>;
  }

  return (
    <div className="flex gap-1.5 flex-wrap items-center">
      {visibleSkills.map((skill) => (
        <button
          key={`${skill.name}-${skill.category}`}
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onSkillClick(skill);
          }}
          className={cn(SKILL_PILL_CLASS, "min-w-0")}
        >
          <span className="truncate">{skill.name}</span>
        </button>
      ))}

      {remainingCount > 0 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onViewAllClick();
          }}
          className={cn(SKILL_PILL_CLASS, "text-gray-600 shrink-0")}
        >
          +{remainingCount}
        </button>
      )}
    </div>
  );
};

export default CompactSkillsList;
